import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import HouseIcon from '@mui/icons-material/House';
import PeopleIcon from '@mui/icons-material/People';
import LocalOfferIcon from '@mui/icons-material/LocalOffer'; // Item/Tag icon
import PersonIcon from '@mui/icons-material/Person';
import Home from "./components/pages/Home";
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";
import NoteIcon from '@mui/icons-material/Note';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InventoryIcon from '@mui/icons-material/Inventory';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentsIcon from '@mui/icons-material/Payments';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ArticleIcon from '@mui/icons-material/Article';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import InfoIcon from '@mui/icons-material/Info';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PaidIcon from '@mui/icons-material/Paid';

import ItemIndex from './components/pages/Item/Index';
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemDetail from "./components/pages/Item/Detail";
import ContactsIcon from '@mui/icons-material/Contacts';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';

//Bank
import BankIndex from "./components/pages/Bank/Index";
import BankCreate from "./components/pages/Bank/Create";
import BankEdit from "./components/pages/Bank/Edit";
//Account Head
import ExpenseHeadIndex from "./components/pages/ExpenseHead/Index";
import ExpenseHeadCreate from "./components/pages/ExpenseHead/Create";
import ExpenseHeadEdit from "./components/pages/ExpenseHead/Edit";

//Master
import MasterIndex from "./components/pages/Master/Index";
//Income
import IncomeIndex from "./components/pages/Income/Index";
import IncomeCreate from "./components/pages/Income/Create";
import IncomeEdit from "./components/pages/Income/Edit";
//Expense
import ExpenseIndex from "./components/pages/Expense/Index";
import ExpenseCreate from "./components/pages/Expense/Create";
import ExpenseEdit from "./components/pages/Expense/Edit";
//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
//PurchaseReturn
import PurchaseReturnIndex from "./components/pages/purchasereturn/Index";
import PurchaseReturnCreate from "./components/pages/purchasereturn/Create";
import PurchaseReturnEdit from "./components/pages/purchasereturn/Edit";
import PurchaseReturnDetails from "./components/pages/purchasereturn/Details";
//SalesMan
import SalesManCreate from "./components/pages/SalesMan/Create";
import SalesManIndex from "./components/pages/SalesMan/Index";
import SalesManEdit from "./components/pages/SalesMan/Edit";
//Sale
import SaleIndex from "./components/pages/sale/Index";
import SaleCreate from "./components/pages/sale/Create";
import SaleEdit from "./components/pages/sale/Edit";
import SaleDetails from "./components/pages/sale/Details";
//Sale Return
import SaleReturnIndex from "./components/pages/salereturn/Index";
import SaleReturnCreate from "./components/pages/salereturn/Create";
import SaleReturnEdit from "./components/pages/salereturn/Edit";
import SaleReturnDetails from "./components/pages/salereturn/Details";
//Receipt
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptEdit from "./components/pages/Receipt/Edit";
//Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentEdit from "./components/pages/Payment/Edit";

//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//Proforma
import ProformaIndex from "./components/pages/Proforma/Index";
import ProformaCreate from "./components/pages/Proforma/Create";
import ProformaEdit from "./components/pages/Proforma/Edit";
import ProformaDetails from "./components/pages/Proforma/Details";
import ToSale from "./components/pages/Proforma/ToSale";
//stock Journal 
import StockJournalIndex from "./components/pages/StockJournal/Index";
import StockJournalCreate from "./components/pages/StockJournal/Create";
import StockJournalDetails from "./components/pages/StockJournal/Details";
import StockJournalEdit from "./components/pages/StockJournal/Edit";
//
//Report
import Ledger from "./components/pages/Reports/Ledger";
import CustomerOutstanding from "./components/pages/Reports/CustomerOutstanding";
import Stock from "./components/pages/Reports/Stock";
import ExecutiveCollection from "./components/pages/Reports/ExecutiveWiseCollection";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [serviceOpen, setserviceOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleserviceClick = () => {
    setserviceOpen(!serviceOpen);
  };


  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };


  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        <AppBar position="static" style={{ backgroundColor: '#003161', height: '50px' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center' }}>
                  {/* <FiHome style={{ marginRight: '8px' }} /> */}
                  {/* <GrassIcon style={{ color: 'wheat', marginRight: '8px' }} /> */}
                  <Typography variant="h6" component="div" style={{ marginLeft: '7px' }}>
                    {companyName}
                  </Typography>


                </Link>
              </div>

              {/* <Typography variant="h6" component="div" style={{ justifyContent: "flex-end", display: 'flex', fontSize: '16px' }}>
                Welcome {username}
              </Typography> */}
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
                <Logout />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <HouseIcon style={{ color: 'darkslateblue' }} /> <ListItemText primary="HOME" />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/MasterIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'black' }} /> <ListItemText primary="Registration" />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LocalOfferIcon style={{ color: 'teal' }} /> <ListItemText primary="Item" />
                </ListItem>

                <ListItem button component={NavLink} to="/BankIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceIcon style={{ color: 'red', fontWeight: 'bolder' }} />  <ListItemText primary="Bank" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ExpenseHeadIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <NoteIcon style={{ color: '#E14D2A', fontWeight: 'bolder' }} />  <ListItemText primary="Account Head" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SalesManIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ContactsIcon style={{ color: 'red' }} /><ListItemText primary="SALES MAN" style={{ marginLeft: '3px' }} />
                </ListItem>
              </List>
            </Collapse>

            <ListItem button onClick={handleserviceClick}>
              <ListItemText primary="TRANSACTION" />
              {serviceOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={serviceOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AssignmentReturnIcon style={{ color: 'blueviolet' }} /><ListItemText primary="Purchase Return" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AddShoppingCartIcon style={{ color: 'darkolivegreen' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ProformaIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ProductionQuantityLimitsIcon style={{ color: '#FF8787' }} /><ListItemText primary="Proforma" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <RemoveShoppingCartIcon style={{ color: 'darkorange' }} /><ListItemText primary="Sale Return" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PaymentsIcon style={{ color: '#9B3922', fontWeight: 'bolder' }} />  <ListItemText primary="Payment" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReceiptIcon style={{ color: '#436850', fontWeight: 'bolder' }} />  <ListItemText primary="Receipt" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArrowBackIcon style={{ color: '#ED7D31', fontWeight: 'bolder' }} />  <ListItemText primary="Expense" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/IncomeIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArrowForwardIcon style={{ color: '#D2DE32', fontWeight: 'bolder' }} />  <ListItemText primary="Income" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/StockJournalIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryTwoToneIcon style={{ color: '#532257', fontWeight: 'bolder' }} />  <ListItemText primary="Stock Journal" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleReportClick}>
              <ListItemText primary="REPORT" />
              {reportOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {/* )} */}

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Consolidated Stock" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose}>
                  <LibraryBooksIcon style={{ color: '#9E4784' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px' }} />
                </ListItem>

                {/* <ListItem button component={NavLink} to="/LedgerIncExp" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArticleIcon style={{ color: '#B3005E' }} /><ListItemText primary="Ledger INC/EXP" style={{ marginLeft: '3px' }} />
                </ListItem> */}

                <ListItem button component={NavLink} to="/CustomerOutstanding" activeClassName="selected" onClick={handleDrawerClose}>
                  <LibraryBooksIcon style={{ color: 'darkblue' }} /><ListItemText primary="Outstanding" style={{ marginLeft: '3px' }} />
                </ListItem>

                {/* <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceWalletIcon style={{ color: '#FF8787' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px' }} />
                </ListItem> */}

                {/* <ListItem button component={NavLink} to="/RentDetails" activeClassName="selected" onClick={handleDrawerClose}>
                  <InfoIcon style={{ color: '#025464' }} /><ListItemText primary="Sales Details" style={{ marginLeft: '3px' }} />
                </ListItem> */}

                <ListItem button component={NavLink} to="/ExecutiveCollection" activeClassName="selected" onClick={handleDrawerClose}>
                <PaidIcon style={{ color: '#15B392' }} /><ListItemText primary="Collection Summary" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER" />
              {userOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>
          </List>
        </Drawer>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />
          {/* Item */}
          <Route path="/ItemIndex" component={ItemIndex} />
          <Route path="/ItemCreate" component={ItemCreate} />
          <Route path="/ItemEdit/:id" component={ItemEdit} />
          <Route path="/ItemDetail/:id" component={ItemDetail} />
          {/* Master */}
          <Route path="/MasterIndex" component={MasterIndex} />
          {/* Bank */}
          <Route path="/BankIndex" component={BankIndex} />
          <Route path="/BankCreate" component={BankCreate} />
          <Route path="/BankEdit/:id" component={BankEdit} />
          {/* ExpenseHead */}
          <Route path="/ExpenseHeadIndex" component={ExpenseHeadIndex} />
          <Route path="/ExpenseHeadCreate" component={ExpenseHeadCreate} />
          <Route path="/ExpenseHeadEdit/:id" component={ExpenseHeadEdit} />
          {/* Income */}
          <Route path="/IncomeIndex" component={IncomeIndex} />
          <Route path="/IncomeCreate" component={IncomeCreate} />
          <Route path="/IncomeEdit/:id" component={IncomeEdit} />
          {/* Expense */}
          <Route path="/ExpenseIndex" component={ExpenseIndex} />
          <Route path="/ExpenseCreate" component={ExpenseCreate} />
          <Route path="/ExpenseEdit/:id" component={ExpenseEdit} />
          {/* Purchase */}
          <Route path="/PurchaseIndex" component={PurchaseIndex} />
          <Route path="/PurchaseCreate" component={PurchaseCreate} />
          <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
          <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
          {/* Purchase Return*/}
          <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
          <Route path="/PurchaseReturnCreate" component={PurchaseReturnCreate} />
          <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
          <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
          {/* SalesMan */}
          <Route path="/SalesManIndex" component={SalesManIndex} />
          <Route path="/SalesManCreate" component={SalesManCreate} />
          <Route path="/SalesManEdit/:id" component={SalesManEdit} />
          {/* Sale */}
          <Route path="/SaleIndex" component={SaleIndex} />
          <Route path="/SaleCreate" component={SaleCreate} />
          <Route path="/SaleEdit/:id" component={SaleEdit} />
          <Route path="/SaleDetails/:id" component={SaleDetails} />
          {/* Sale Return*/}
          <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
          <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
          <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
          <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />
          {/* Receipt */}
          <Route path="/ReceiptIndex" component={ReceiptIndex} />
          <Route path="/ReceiptCreate" component={ReceiptCreate} />
          <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />
          {/* Payment */}
          <Route path="/PaymentIndex" component={PaymentIndex} />
          <Route path="/PaymentCreate" component={PaymentCreate} />
          <Route path="/PaymentEdit/:id" component={PaymentEdit} />
          {/* User */}
          <Route path="/UserIndex" component={UserIndex} />
          <Route path="/UserCreate" component={UserCreate} />
          <Route path="/UserEdit/:id" component={UserEdit} />
          <Route path="/UserDetail/:id" component={UserDetail} />
          <Route path="/PasswordChange" component={PasswordChange} />
          {/* Role */}
          <Route path="/RoleIndex" component={RoleIndex} />
          <Route path="/RoleDetail/:id" component={RoleDetail} />
          {/* Proforma */}
          <Route path="/ProformaIndex" component={ProformaIndex} />
          <Route path="/ProformaCreate" component={ProformaCreate} />
          <Route path="/ProformaEdit/:id" component={ProformaEdit} />
          <Route path="/ProformaDetails/:id" component={ProformaDetails} />
          <Route path="/ToSale/:id" component={ToSale} />
          {/* StockJournal */}
          <Route path="/StockJournalIndex" component={StockJournalIndex} />
          <Route path="/StockJournalCreate" component={StockJournalCreate} />
          <Route path="/StockJournalDetails/:id" component={StockJournalDetails} />
          <Route path="/StockJournalEdit/:id" component={StockJournalEdit} />
          {/* Report */}
          <Route path="/Ledger" component={Ledger} />
          <Route path="/CustomerOutstanding" component={CustomerOutstanding} />
          <Route path="/Stock" component={Stock} />
           {/* Report */}
           <Route path="/Ledger" component={Ledger} />
           <Route path="/CustomerOutstanding" component={CustomerOutstanding} />
           <Route path="/ExecutiveCollection" component={ExecutiveCollection} />
        </Switch>
      </AuthProvider >
    </Router>
  );
};

export default App;

